// extracted by mini-css-extract-plugin
export default {"courses-section":"CourseList_courses-section__1zpEv","course-list":"CourseList_course-list__dLmfI","forward":"CourseList_forward__f72bi","backward":"CourseList_backward__jHZ1k"};